import { useClientPortalAPI } from "@certn/api";

export function useClientAccount() {
  const {
    data: details,
    isLoading,
    mutate,
  } = useClientPortalAPI("/api/internal/client-portal/me/", undefined);
  const client = details?.client_account;
  const customerGroups = details?.customer_groups;

  return {
    client,
    customerGroups,
    isLoading,
    mutate,
  };
}
